/** Learning Center hub copy (see `src/constants/learningCenterHub.ts` for defaults). */

export interface LearningCenterHubProgressLabels {
  none: string;
  partial: string;
  complete: string;
}

export interface LearningCenterHubJson {
  heroDescription?: string;
  progressLabels?: Partial<LearningCenterHubProgressLabels>;
  /** Template: `{completed}` and `{total}` placeholders */
  countFormat?: string;
  seeMoreLabel?: string;
  seeLessLabel?: string;
  emptyStateMessage?: string;
}

const DEFAULT_PROGRESS: LearningCenterHubProgressLabels = {
  none: "Let's get started!",
  partial: "You're on your way!",
  complete: 'All done!',
};

export function normalizeLearningCenterHubJson(raw: unknown): Required<
  Omit<LearningCenterHubJson, 'progressLabels'>
> & { progressLabels: LearningCenterHubProgressLabels } {
  const o = raw && typeof raw === 'object' ? (raw as Record<string, unknown>) : {};
  const pl = o.progressLabels && typeof o.progressLabels === 'object' ? (o.progressLabels as Record<string, unknown>) : {};

  return {
    heroDescription:
      typeof o.heroDescription === 'string' && o.heroDescription.trim()
        ? o.heroDescription.trim()
        : 'Get important information on what to expect before your learning journey begins.',
    progressLabels: {
      none: typeof pl.none === 'string' && pl.none.trim() ? pl.none.trim() : DEFAULT_PROGRESS.none,
      partial:
        typeof pl.partial === 'string' && pl.partial.trim() ? pl.partial.trim() : DEFAULT_PROGRESS.partial,
      complete:
        typeof pl.complete === 'string' && pl.complete.trim()
          ? pl.complete.trim()
          : DEFAULT_PROGRESS.complete,
    },
    countFormat:
      typeof o.countFormat === 'string' && o.countFormat.trim()
        ? o.countFormat.trim()
        : '{completed}/{total} complete',
    seeMoreLabel:
      typeof o.seeMoreLabel === 'string' && o.seeMoreLabel.trim() ? o.seeMoreLabel.trim() : 'See more',
    seeLessLabel:
      typeof o.seeLessLabel === 'string' && o.seeLessLabel.trim() ? o.seeLessLabel.trim() : 'See less',
    emptyStateMessage:
      typeof o.emptyStateMessage === 'string' && o.emptyStateMessage.trim()
        ? o.emptyStateMessage.trim()
        : 'No items available yet.',
  };
}
